import { useState, useEffect } from 'react'
import * as API from '../lib/JerseyDirectoryAPI'

function UseDirectory() {

    // Holds the state values for the listing search user input
    const [inputSearchText, setInputSearchText] = useState(null);
    const [inputLocation, setInputLocation] = useState(null);
    const [inputCategory, setInputCategory] = useState(null);
    const [inputSubCategory, setInputSubCategory] = useState(null);
    const [inputListingPlan, setInputListingPlan] = useState(null);

    // Gets the state options available to the application
    const [stateOptions, setStateOptions] = useState([]);
    const [isStatesLoaded, setIsStatesLoaded] = useState(false); 
    useEffect(() => {
        API.getActiveStates().then((res) => {
            let deserializedStates = res.data;
            setStateOptions(deserializedStates);
            setIsStatesLoaded(true);
        })
    }, [])

    // Gets the country options that are available to the application
    const [countryOptions, setCountryOptions] = useState([])
    const [isCountriesLoaded, setIsCountriesLoaded] = useState(false);
    useEffect(() => {
        API.getActiveCountries().then((res) => {
            let deserializedCountries = res.data;
            setCountryOptions(deserializedCountries);
            setIsCountriesLoaded(true);
        })
    }, [])

    // Gets the listing plan options that are available to the application
    const [listingPlans, setListingPlans] = useState([]);
    const [isListingPlansLoaded, setIsListingPlansLoaded] = useState(false);
    useEffect(() => {
        API.getActiveListingPlans().then((res) => {
            let deserializedListingPlans = res.data;
            setListingPlans(deserializedListingPlans);
            setIsListingPlansLoaded(true);
        })
    }, [])

    // Gets the category options that are available to the application
    const [categoryOptions, setCategoryOptions] = useState([]);
    const [isCategoriesLoaded, setIsCategoriesLoaded] = useState(false);
    useEffect(() => {
        API.getActiveCategories().then((res) => {
            let deserializedCategories = res.data;
            setCategoryOptions(deserializedCategories);
            setIsCategoriesLoaded(true);
        })
    }, [])

    // Gets the sub category options that are available to the application
    const [subCategoryOptions, setSubCategoryOptions] = useState([]);
    const [isSubCategoriesLoaded, setIsSubCategoriesLoaded] = useState(false);
    useEffect(() => {
        API.getActiveSubCategories().then((res) => {
            let deserializedSubCategories = res.data;
            setSubCategoryOptions(deserializedSubCategories);
            setIsSubCategoriesLoaded(true);
        })
    }, [])

    // Gets the contact type options that are available to the application
    const [contactTypeOptions, setContactTypeOptions] = useState([]);
    const [isContactOptionsLoaded, setIsContactOptionsLoaded] = useState(false) 
    useEffect(() => {
        API.getContactTypes().then((res) => {
            let deserializedContactTypes = res.data;
            setContactTypeOptions(deserializedContactTypes);
            setIsContactOptionsLoaded(true);
        })
    }, [])

    return {
        stateOptions,
        isStatesLoaded,
        countryOptions,
        isCountriesLoaded,
        categoryOptions,
        isCategoriesLoaded,
        subCategoryOptions, 
        isSubCategoriesLoaded,
        listingPlans,
        isListingPlansLoaded,
        contactTypeOptions,
        isContactOptionsLoaded,
        inputSearchText,
        setInputSearchText,
        inputLocation,
        setInputLocation,
        inputCategory,
        setInputCategory,
        inputSubCategory,
        setInputSubCategory,
        inputListingPlan,
        setInputListingPlan,
    }
}

export default UseDirectory